import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UsermanagementRoutingModule } from './usermanagement-routing.module';
import { UsermanagementComponent } from './components/usermanagement/usermanagement.component';
import { AngularFireFunctionsModule } from '@angular/fire/functions'
import { MatCardModule } from '@angular/material/card';
import { SharedModule } from '../../shared/shared/shared.module';

@NgModule({
  declarations: [UsermanagementComponent],
  imports: [
    CommonModule,
    UsermanagementRoutingModule,
    AngularFireFunctionsModule,
    MatCardModule,
    SharedModule
  ]
})
export class UsermanagementModule { }
